import { SwiperSlide } from 'swiper/react';

import { BlockProgram } from '@/components/BlockProgram';
import { Breakpoints } from '@/types';

import { BlockProgramProps } from './CarouselBlock';
import { SwiperBlock } from './SwiperBlock';

export const HeaderCarouselBlock = ({ block }: BlockProgramProps) => {
  const { items: programs } = block;

  return (
    <div className="w-full my-4 mx-auto">
      <SwiperBlock
        slidesPerView={2.2}
        slidesPerGroup={2}
        spaceBetween={10}
        slidesOffsetAfter={20}
        slidesOffsetBefore={20}
        navigation={true}
        freeMode={true}
        className="block-swiper"
        breakpoints={{
          [Breakpoints.Medium]: {
            slidesPerView: 3.3,
            slidesPerGroup: 3,
          },
          [Breakpoints.Large]: {
            slidesPerView: 4.4,
            slidesPerGroup: 4,
          },
          [Breakpoints.ExtraLarge]: {
            slidesPerView: 5.5,
            slidesPerGroup: 5,
          },
        }}
      >
        {programs.map((program) => (
          <SwiperSlide key={program.UUID} className="drop-shadow">
            <BlockProgram program={program} block={block} />
          </SwiperSlide>
        ))}
      </SwiperBlock>
    </div>
  );
};
